import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Company } from './company';
import { Vendor } from './vendor';
import { VendorInvite } from './vendor-invite';

export class InvitationContact extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static InvitationContactProperties: (
    | {
        property: keyof InvitationContact;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof InvitationContact;
        type: 'alias';
      }
    | {
        property: keyof InvitationContact;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'VendorInviteId', type: 'column', dataType: 'number' },
    { property: 'dba', type: 'column', dataType: 'string' },
    { property: 'email', type: 'column', dataType: 'string' },
    { property: 'address1', type: 'column', dataType: 'string' },
    { property: 'address2', type: 'column', dataType: 'string' },
    { property: 'city', type: 'column', dataType: 'string' },
    { property: 'state', type: 'column', dataType: 'string' },
    { property: 'zip', type: 'column', dataType: 'string' },
    { property: 'phone1', type: 'column', dataType: 'string' },
    { property: 'phone2', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Company', model: 'Company', type: 'association' },
    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'VendorInvite', model: 'VendorInvite', type: 'association' }
  ];

  static {
    InvitationContact.InvitationContactProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        InvitationContact.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        InvitationContact.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        InvitationContact.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(InvitationContactObject: Partial<InvitationContact>) {
    super();

    InvitationContact.InvitationContactProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = InvitationContactObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyId?: number;
  VendorId?: number;
  VendorInviteId?: number;
  legalName?: string | null;
  dba?: string | null;
  email?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  phone1?: string | null;
  phone2?: string | null;
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  Vendor?: Vendor;
  VendorInvite?: VendorInvite;
}
